import React, { useState, useEffect, useRef } from 'react';
import Drawer from '@material-ui/core/Drawer';
// import { dynamicLayoutItemDetailStyle } from '../../style_detail/style';
import utils from 'utils/utils';
import { ReactComponent as CloseIconBlack } from 'assets/svg/close-black.svg';
import { ReactComponent as OpenNewTab } from 'assets/svg/open-new-tab-black.svg';
import { ProductTypeEnum } from '__generated__/globalTypes';
import { useTranslation } from 'react-i18next';
import { PATH } from 'routes/constant';
import CanvasLayoutStyle from 'containers/style_detail/canvas_layout_style';
import ReactionActions from './ReactionActions';
import WidgetPopup from 'component/popup/customize_popup';
import { WidgetCode } from 'component/popup/constant';
import { LanguageCode } from '../../../__generated__/globalTypes';
import styleItemUtils from '../../../utils/style_item';
import { TRACK_EVENT } from 'utils/analytics';
import { STRINGS } from '../../../constants/strings';

export default function EngagingSliderPreview({
    isEngageSliderPreviewOpen,
    handleCloseStylePreview,
    selectedStyle,
    handleAnalytics,
}) {
    const { t } = useTranslation();
    const [updatedStyle, setUpdatedStyle] = useState(selectedStyle);
    const styleUpdated = useRef(false);
    const [styleData, setStyleData] = useState<any>(null);
    const [shopItems, setShopItems] = useState<any[]>([]);

    const handleShopNow = (style) => {
        let clickedItem: string | null = null;
        let shopNowItems: string[] = [];
        for (const item of style.items) {
            try {
                if (item?.data?.taffiId && item?.data?.taffiId === style?.itemTaffiId) {
                    clickedItem = item;
                } else {
                    shopNowItems.push(item);
                }
            } catch (e) {
                console.log('Error get item url ', e);
            }
        }
        if (clickedItem) {
            shopNowItems = [clickedItem, ...shopNowItems];
        }
        shopNowItems = styleItemUtils.mapItemDataWithPrimaryImages(shopNowItems, style);
        setShopItems(shopNowItems);
        setStyleData(styleData);
    };

    const handleShopNowClick = (updatedStyle) => {
        handleAnalytics(TRACK_EVENT.BUSY_INDICATOR_WITH_STYLES, updatedStyle, {
            state: STRINGS.STYLE_SHOPPED,
        });
        if (updatedStyle?.productType === ProductTypeEnum.item) {
            utils.openUrl(updatedStyle.url as string, {
                from: PATH.PDP_WIDGET,
                messageTaffiId: updatedStyle.taffiId,
                productTaffiId: updatedStyle.productTaffiId,
            });
        } else {
            handleShopNow(updatedStyle);
        }
    };

    const handleClosePreview = (item) => {
        handleCloseStylePreview(item);
        setUpdatedStyle({});
        styleUpdated.current = false;
    };

    useEffect(() => {
        if (isEngageSliderPreviewOpen && !styleUpdated.current) {
            setUpdatedStyle(selectedStyle);
            styleUpdated.current = true;
        }
    }, [selectedStyle, isEngageSliderPreviewOpen]);

    return (
        <>
            <Drawer
                open={isEngageSliderPreviewOpen}
                onClose={handleClosePreview}
                anchor="bottom"
                PaperProps={{
                    style: {
                        height: '80%',
                        borderTopRightRadius: 24,
                        borderTopLeftRadius: 24,
                    },
                }}
            >
                <div className="style-preview-modal-container" style={{ border: 'none' }}>
                    <div className="style-preview-header-container">
                        <div onClick={handleClosePreview} className="close-icon-container">
                            <CloseIconBlack />
                        </div>
                    </div>
                    <div className="style-preview-image-container">
                        {updatedStyle?.productType === ProductTypeEnum.item ? (
                            <img
                                src={updatedStyle?.value!!}
                                alt="style"
                                style={{
                                    height: 400,
                                    width: '100%',
                                    objectFit: 'contain',
                                }}
                                className="style-image cursor-pointer"
                            />
                        ) : (
                            <CanvasLayoutStyle
                                style={updatedStyle}
                                items={selectedStyle?.items}
                                heightContent={400}
                                isInPdpWidget={true}
                                handleShopNow={(styleData) => {
                                    handleShopNowClick({
                                        ...updatedStyle,
                                        itemTaffiId: styleData?.itemTaffiId,
                                        itemUrl: styleData?.itemUrl,
                                    });
                                }}
                            />
                        )}
                    </div>
                    <div className="style-preview-footer-container">
                        <ReactionActions
                            productDetail={{
                                ...selectedStyle,
                                collectionName: selectedStyle?.collection,
                                productType: 'style',
                                productId: selectedStyle?.id,
                                productTaffiId: selectedStyle?.taffiId,
                            }}
                        />
                        <div
                            className="cursor-pointer"
                            onClick={() => {
                                handleShopNowClick(updatedStyle);
                            }}
                        >
                            {updatedStyle?.productType === ProductTypeEnum.item ? (
                                <div className="taffi-shop-now-button ">
                                    {t('shop_the_item')}
                                    <OpenNewTab width={16} height={16} fill={'#ffffff'} />
                                </div>
                            ) : (
                                <div className="taffi-shop-now-button ">{t('shop_now')}</div>
                            )}
                        </div>
                    </div>
                </div>
                <WidgetPopup
                    isOpen={Boolean(shopItems.length)}
                    titlePopup={t('view_style_detail')}
                    widgetCode={WidgetCode.ViewDetailStyle}
                    listItem={shopItems}
                    setListItem={() => {}}
                    onClose={() => {
                        setShopItems([]);
                    }}
                    // isButton={!(utils.isAppInWidgetMode() || config.removeCheckOut)}
                    isButtonWhite={false}
                    titleButton={'Add all to bag'}
                    shortPopup={false}
                    loading={false}
                    styleData={styleData}
                    language={LanguageCode.english}
                    drawerVariant={'persistent'} // Use this variant to fix scrolling to the bottom of the parent page in widget mode.
                    isFullScreenOnWidget={true}
                    restrictExistingEvent={true}
                />
            </Drawer>
        </>
    );
}
